import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Base, SidebarItem, Typography } from 'lib/cortiUI';
export const NewViewItem = () => {
    const { t } = useTranslation('performanceApp');
    return (React.createElement(SidebarItem, { selected: true, "data-cy": "performance-draft-view-item" },
        React.createElement(Base, { display: "flex", width: "100%" },
            React.createElement(Typography, { variant: "body2", fontStyle: "italic", width: "100%" }, t('newViewDraftTitle', 'New View')))));
};
